namespace TabAurous.ECommerce {
    export interface ECommRefundForm {
        Date: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        EnteredBy: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        ECommRefundDetails: ECommRefundDetailsEditor;
        PartyBalance: ECommRefundBalanceEditor;
        UserId: Serenity.DecimalEditor;
        RefundTotal: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        Url: Serenity.StringEditor;
        RefundECommsible: Serenity.DecimalEditor;
        VoucherTypeId: Serenity.IntegerEditor;
    }

    export class ECommRefundForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommRefund';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommRefundForm.init)  {
                ECommRefundForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = ECommRefundDetailsEditor;
                var w6 = ECommRefundBalanceEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(ECommRefundForm, [
                    'Date', w0,
                    'VoucherNo', w1,
                    'POSCustomerId', w2,
                    'LedgerName', w1,
                    'Mobile', w1,
                    'Email', w1,
                    'RefNo', w1,
                    'RefDate', w0,
                    'EnteredBy', w1,
                    'CurrencyId', w3,
                    'ExchangeRate', w4,
                    'ECommRefundDetails', w5,
                    'PartyBalance', w6,
                    'UserId', w4,
                    'RefundTotal', w4,
                    'TotalAmount', w4,
                    'Narration', w1,
                    'Url', w1,
                    'RefundECommsible', w4,
                    'VoucherTypeId', w7
                ]);
            }
        }
    }
}
